// extracted by mini-css-extract-plugin
export default {"wrapper_input":"styles_wrapper_input__xPoYp","input":"styles_input__dBChp","buttonDeleteSearch":"styles_buttonDeleteSearch__DeDCa"};